/** POST SSE のフレームと順番を検証する。本文は保持・ログ出力しない。 */
export type SSEEvent = { event: string; data: unknown };
export class SSEParser {
  private line = "";
  private data: string[] = [];
  private event = "message";
  private frameSize = 0;
  private skipLF = false;
  private seenMeta = false;
  private terminal = false;
  private encoder = new TextEncoder();

  push(chunk: string): SSEEvent[] {
    if (this.encoder.encode(chunk).length + this.encoder.encode(this.line).length > 256 * 1024) throw new Error("network");
    const output: SSEEvent[] = [];
    const finishLine = () => {
      const line = this.line;
      this.line = "";
      if (line === "") {
        if (this.data.length && ["meta", "delta", "done", "error"].includes(this.event)) {
          if (this.terminal || (this.event === "meta" ? this.seenMeta : !this.seenMeta)) throw new Error("network");
          const data: unknown = JSON.parse(this.data.join("\n"));
          if (!data || typeof data !== "object") throw new Error("network");
          if (this.event === "meta") this.seenMeta = true;
          if (this.event === "done" || this.event === "error") this.terminal = true;
          output.push({ event: this.event, data });
        }
        this.data = []; this.event = "message"; this.frameSize = 0;
      } else if (!line.startsWith(":")) {
        const colon = line.indexOf(":");
        const field = colon === -1 ? line : line.slice(0, colon);
        let value = colon === -1 ? "" : line.slice(colon + 1);
        if (value.startsWith(" ")) value = value.slice(1);
        if (field === "data") this.data.push(value);
        if (field === "event") this.event = value;
      }
    };
    for (const ch of chunk) {
      if (this.skipLF) { this.skipLF = false; if (ch === "\n") continue; }
      this.frameSize += this.encoder.encode(ch).length;
      if (this.frameSize > 64 * 1024) throw new Error("network");
      if (ch === "\r" || ch === "\n") { finishLine(); this.skipLF = ch === "\r"; }
      else this.line += ch;
    }
    return output;
  }
  end() { if (!this.terminal || this.line || this.data.length) throw new Error("network"); }
}

export async function readSSE(response: Response, onEvent: (event: SSEEvent) => void) {
  if (!response.body || !response.headers.get("content-type")?.includes("text/event-stream")) throw new Error("network");
  const reader = response.body.pipeThrough(new TextDecoderStream("utf-8", { fatal: true })).getReader();
  const parser = new SSEParser();
  try {
    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      for (const event of parser.push(value)) onEvent(event);
    }
    parser.end();
  } finally {
    await reader.cancel().catch(() => undefined);
    reader.releaseLock();
  }
}
